import React from "react";

import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  ${({ language }) =>
    language === "kh"
      ? `
        *:not([class*=icons]):not([class*=fa-]) {
          font-family: battambang, Roboto, Helvetica, Arial, sans-serif !important;
        }
      `
      : ""}
`;

function GlobalStyleContainer({ language }) {
  return <GlobalStyle language={language} />;
}

export default GlobalStyleContainer;



// WEBPACK FOOTER //
// ./src/GlobalPolicyStyle.jsx